export const theme = {
  // ===== BRAND COLORS =====
  primary: '#2563eb',       // Kentexa Blue
  primaryLight: '#60a5fa',
  primaryDark: '#1d4ed8',

  // ===== ACTION COLORS =====
  accent: '#f97316',        // Orange for CTA buttons
  accentLight: '#fb923c',

  success: '#10b981',
  warning: '#f59e0b',
  danger: '#ef4444',

  // ===== EXTRA COLORS =====
  purple: '#7c3aed',
  pink: '#db2777',
  cyan: '#06b6d4',

  // ===== BACKGROUNDS =====
  white: '#ffffff',
  background: '#f8fafc',
  card: '#ffffff',

  // ===== TEXT =====
  text: '#0f172a',
  textSecondary: '#475569',
  textMuted: '#94a3b8',

  // ===== BORDERS =====
  border: '#e2e8f0',
  borderDark: '#cbd5e1',

  // ===== SHADOWS =====
  shadow: '0 2px 8px rgba(0,0,0,0.08)',
  shadowHover: '0 8px 24px rgba(0,0,0,0.12)',

  // ===== GRADIENTS =====
  heroGradient:
    'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)',

  successGradient:
    'linear-gradient(135deg, #10b981 0%, #34d399 100%)',

  warningGradient:
    'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',

  dangerGradient:
    'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',

  cardGradient:
    'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
};  